import React, { useState } from 'react';
import { updateMultiCanvas } from '../../../../redux/homeActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Popover,
  Form,
  FormGroup,
  Label,
  FormFeedback,
  Input,
  InputGroup,
  Button
} from 'reactstrap';
import { columnChange, rowChange } from '../../../../redux/actions/sizeHandler';
import { string } from '../../../../localization';

const multiCanvasPopover = props => {
  const {
    multiCanvas,
    dispatchers,
    multiCanvasPopoverStatus
    // handleMultiCanvasPopover
  } = props;
  const {
    rowValid,
    columnValid,
    multiCanvasErrorMessage,
    rowErrorMessage,
    colErrorMessage,
    row,
    column
  } = multiCanvas;
  const [multiCanvasRow, setMultiCanvasRow] = useState(row);
  const [multiCanvasColumn, setMultiCanvasColumn] = useState(column);
  let message = multiCanvasErrorMessage;
  if (message == '') {
    message = rowErrorMessage != '' ? rowErrorMessage : colErrorMessage;
  }

  return (
    <Popover
      placement='bottom'
      isOpen={multiCanvasPopoverStatus}
      target='multi-canvas'
      boundariesElement='window'
      //   toggle={handleMultiCanvasPopover}
    >
      <Form
        className='popover-form p-2'
        onSubmit={dispatchers.updateMultiCanvas}
      >
        <FormGroup className='popover-row p-2'>
          <Label>{string.ROWS_KEY}</Label>
          <InputGroup>
            <div
              className={
                !rowValid
                  ? 'valid-dimension input-field-border'
                  : 'invalid-dimension'
              }
            >
              <Input
                type='number'
                bsSize='lg'
                value={multiCanvasRow}
                // onKeyDown={this.goToNextPage}
                onChange={e => {
                  setMultiCanvasRow(e.target.value);
                  dispatchers.rowChange(e.target.value);
                }}
              />
            </div>
          </InputGroup>
        </FormGroup>

        <FormGroup className='popover-column p-2'>
          <Label>{string.COLUMNS_KEY}</Label>
          <InputGroup>
            <div
              className={
                !columnValid
                  ? 'valid-dimension input-field-border'
                  : 'invalid-dimension'
              }
            >
              <Input
                type='number'
                bsSize='lg'
                value={multiCanvasColumn}
                // onKeyDown={this.goToNextPage}
                onChange={e => {
                  setMultiCanvasColumn(e.target.value);
                  dispatchers.columnChange(e.target.value);
                }}
              />
            </div>
          </InputGroup>
        </FormGroup>

        <FormFeedback className='d-block p-1'>{message}</FormFeedback>
        <Button className='d-none' />
      </Form>
    </Popover>
  );
};

function mapStateToProps(state) {
  return {
    multiCanvas: state.home.multiCanvas
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      updateMultiCanvas: bindActionCreators(updateMultiCanvas, dispatch),
      columnChange: bindActionCreators(columnChange, dispatch),
      rowChange: bindActionCreators(rowChange, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(multiCanvasPopover);
